import {
  MESSAGE_ROLES,
  THREAD_DELETE_BLOCKED_MESSAGE,
  THREAD_DELETE_FAILED_MESSAGE
} from '../../../constants/aiAnalytics';
import { formatDate } from '../../../services/date';

import { messageIdOf } from './services/aiDataUtils';

const HTTP_CONFLICT = 409;

const DEFAULT_CHART_NAME_SEED = 'AI Analytics Chart';
const CHART_NAME_WORD_COUNT = 6;
const CHART_NAME_STAMP_FORMAT = 'DDMMMYY';

export function deriveChartName(seed) {
  const base = (seed || DEFAULT_CHART_NAME_SEED)
    .replace(/[\n\r]+/g, ' ')
    .split(/\s+/)
    .slice(0, CHART_NAME_WORD_COUNT)
    .join(' ')
    .replace(/[.?!,]+$/, '');
  const stamp = formatDate(new Date(), CHART_NAME_STAMP_FORMAT).toUpperCase();
  return `${base}_${stamp}`;
}

export function questionForMessage(messages, index) {
  for (let position = index - 1; position >= 0; position -= 1) {
    if (messages[position]?.role === MESSAGE_ROLES.USER) {
      return messages[position].content;
    }
  }
  return null;
}

export function sortThreads(threads) {
  return [...threads].sort((a, b) => (b.favorite ? 1 : 0) - (a.favorite ? 1 : 0));
}

export function threadDeleteErrorMessage(error) {
  if (error?.response?.status === HTTP_CONFLICT) {
    return error.response.data?.message || THREAD_DELETE_BLOCKED_MESSAGE;
  }
  return THREAD_DELETE_FAILED_MESSAGE;
}

export function buildOpLabelMaps(pendingOps) {
  const threadOpLabels = {};
  const chartOpLabels = {};
  Object.values(pendingOps || {}).forEach(function(op) {
    if (op.chartId) {
      chartOpLabels[op.chartId] = op.label;
    } else if (op.threadId && !threadOpLabels[op.threadId]) {
      threadOpLabels[op.threadId] = op.label;
    }
  });
  return { threadOpLabels, chartOpLabels };
}

function contentHash(text) {
  let hash = 0;
  for (let index = 0; index < text.length; index += 1) {
    hash = (hash * 31 + text.charCodeAt(index)) | 0;
  }
  return Math.abs(hash).toString(36);
}

export function messageKeyOf(message, index) {
  return messageIdOf(message) || `${index}-${contentHash(message?.content || '')}`;
}
